import { all, call, put, takeLeading } from 'redux-saga/effects' ;
import { types, actions } from '@src/store';
import firebaseDB from '@src/firebase/database';
import { fetchAvatars } from '@src/apis/Settings';

const logger = Logger.get( 'firebase data' );

const getProfilePath = ( profile ) => `/${ profile.profileid }/levels/${ profile.currentLevel }` ;
const getdisabledlevelspath =( profile ) => `/${ profile.profileid }` ;


function* FirebaseSaga() {
    yield all( [
                takeLeading( types.firebase.GetDisabledCourses, getDisabledCourses),
                takeLeading( types.firebase.GetDisabledLevels, getDisabledLevels),
                takeLeading( types.firebase.GetCourses, getCourses ),
                takeLeading( types.firebase.GetLessons, getLessons ),
                takeLeading( types.firebase.GetProfileData, getProfileData ),
                
            ] )
}

function* getProfileData( { payload } ){

    const { profile } = payload ;
    const basepath = `/${ profile.profileid }`;
    const [ 
        currentLevel,
        onboardLevel,
        browsingmode,
        timerData,
        avatarid
       ]   = yield all( 
            [ 
                call( getNodeValue, basepath + '/levels/current' ),
                call( getNodeValue, basepath + '/levels/onboard' ),
                call( getNodeValue, basepath + '/browsingmodeenabled' ),
                call( getNodeValue, basepath + '/timecontrol' ),
                call( getNodeValue, basepath + '/avatar/current')
            ]
            );

    if( profile.firesynced ) return ;

    const profileData = {
        ...( currentLevel && { currentLevel } ),
        ...( onboardLevel && { onboardLevel } ),
        browsingmode: browsingmode ?? false,
        timerData,
        avatarid: avatarid || 'fallback-profile-id',
        profileid: profile.profileid,
        firesynced: true
    }
    yield put( actions.profile.SetLocalProfile( { ...profileData } ) );
    yield call( getCurrentAvatar, avatarid );
}

function* getNodeValue( path ){
    try{
        const response = yield call ( firebaseDB.getSubscriberPath().ref( path ).get ) ;
        return response;
    }
    catch( error ){
        logger.log( error );
        return null ;
    }
}

function* getCurrentAvatar( avatarid ){
    try{
        const avatars = yield call( fetchAvatars );

        yield put( actions.avatars.SetAvatars( { avatars } ) );

        yield put( actions.avatars.SetCurrent( { avatarid : avatarid || 'fallback-profile-id' } ) );
        
    }
    catch( error ){
        logger.log( error );
        return null ;
    }
}

function* getDisabledCourses( { payload } ){
    try{
        const { profile } = payload ;
        
        const path = getProfilePath( profile ) + '/disabledcategories';

        let disabledCourses = yield call( firebaseDB.getSubscriberPath().ref( path ).get ) ;

        disabledCourses = disabledCourses ?? [] ;

        yield put( actions.firebase.SetDisabledCourses( { path, profile, disabledCourses, effects: false } ) );

    }
    catch( error ){
        logger.log( error )
    }
}


function* getDisabledLevels( { payload } ){
    try{
        const { profile } = payload ;
        
        const path = getdisabledlevelspath( profile ) + '/disabledlevels';

        let disabledLevels = yield call( firebaseDB.getSubscriberPath().ref( path ).get ) ;

        disabledLevels = disabledLevels ?? [] ;

        yield put( actions.firebase.SetDisabledLevels( { path, profile, disabledLevels, effects: false } ) );

    }
    catch( error ){
        logger.log( error )
    }
}



function* getCourses( { payload } ){
    const { profile } = payload ;

    const path = getProfilePath( profile ) + `/content`;

    const dbCourses = yield call( firebaseDB.getSubscriberPath().ref( path ).get );

    if( !dbCourses ) return ;

    const contents = [];

    for( let courseid in dbCourses ){

        const course = dbCourses[ courseid ]; 

        course.contentid = courseid ;

        contents.push( course );
    }

    yield put( actions.course.UpdateCourses( { contents } ))

}

function* getLessons( { payload }){
    const { profile, seriesid } = payload ;

    const path = getProfilePath( profile ) + `/content/${ seriesid }`;

    let dbCourse = yield call( firebaseDB.getSubscriberPath().ref( path ).get );

    const dbLessons = dbCourse?.lessons ;

    if( !dbLessons ) return ;

    const contents = [];

    for( let lessonid in dbLessons ){

        const story = dbLessons[ lessonid ]; 

        story.contentid = lessonid ;

        contents.push( story );
    }

    yield put( actions.stories.UpdateStories( { contents } ) )

}



export default FirebaseSaga;